import { render, staticRenderFns } from "./gasClampUpstream.vue?vue&type=template&id=6a507f7c&scoped=true"
import script from "./gasClampUpstream.vue?vue&type=script&lang=js"
export * from "./gasClampUpstream.vue?vue&type=script&lang=js"
import style0 from "./gasClampUpstream.vue?vue&type=style&index=0&id=6a507f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a507f7c",
  null
  
)

export default component.exports